import { render, staticRenderFns } from "./ItemFilterCollectionLayout.vue?vue&type=template&id=61f4cf6d&scoped=true&"
import script from "./ItemFilterCollectionLayout.vue?vue&type=script&lang=js&"
export * from "./ItemFilterCollectionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f4cf6d",
  null
  
)

export default component.exports